import { MinimalStory } from '../../state/types'
import globalStyle from '../../styles/common.module.css'
import style from './story.module.css'


const defaultDescriptor = 'an excerpt about'
// ~~~~~~~~~~~~~~~~~~~~ STORY ~~~~~~~~~~~~~~~~~~~~
function About({body, descriptor}: {body: MinimalStory["context"], descriptor: MinimalStory["descriptor"]}) {
  const customDescriptor = descriptor?.trim()
  const descriptorText = customDescriptor?.length ? customDescriptor : defaultDescriptor
  return (
    <div className={[globalStyle.grid6, style.about].join(' ')}>
      <h2 className={[globalStyle.subtitle, globalStyle.underline, style.aboutHeader].join(' ')}>
        {descriptorText}…
        </h2>
      <div className={[globalStyle.bodySMalt, style.aboutBody].join(' ')} dangerouslySetInnerHTML={{ __html: body?.html || '' }} />
    </div>
  )
}

export { About }
